import { loadStripe } from '@stripe/stripe-js';
import { supabase } from './supabase';

// Environment variables — the CLIENT must only ever see the PUBLISHABLE key.
// The Stripe SECRET key lives exclusively in Supabase Edge Function env
// (Deno.env.get('STRIPE_SECRET_KEY')); it must never be a VITE_ var or it gets
// inlined into the public browser bundle.
const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Get Stripe price ID for a plan from database
export const getStripePriceId = async (planId: string): Promise<string | null> => {
  try {
    const { data, error } = await supabase
      .from('subscription_plans')
      .select('stripe_price_id')
      .eq('plan_id', planId)
      .single();

    if (error) {
      console.error('Error fetching Stripe price ID:', error);
      return null;
    }

    return data?.stripe_price_id || null;
  } catch (err) {
    console.error('Error in getStripePriceId:', err);
    return null;
  }
};

// Check if Stripe is configured
export const isStripeConfigured = (): boolean => {
  return !!STRIPE_PUBLISHABLE_KEY;
}; 